export function Footer() {
  return (
    <footer className="border-t border-rule py-8 mt-20">
      <div className="max-w-6xl mx-auto px-12 flex justify-between items-baseline flex-wrap gap-4 font-label text-xs text-ink-muted">
        <div>© 2026 Ashutosh "Ash" Pandey · Notes from twenty years of paying attention.</div>
        <div className="tracking-widest">California</div>
      </div>
    </footer>
  );
}
